export const INVOICE_DESCRIPTION_ALLOWED_CHARACTERS = /^[a-zA-Z0-9äöåÄÖÅÉÁáéüÜœŒæÆøØ.,;"#%&@/\\()=+\-*_?'´\s\n]*$/;  // Allowed characters for description from fortnox

export const handleInvoicingDescriptionChange = async (e, trigger, setValue) => {
  let inputValue = e.target.value;

  const lines = inputValue.split("\n").map((line) => {
    const wrappedLine = [];
    let currentLine = "";
    const words = line.split(" ");
    const maxCharactersInRow = 49; // As Fortnox doesn't allow more than 49 characters in a row for description.

    words.forEach((word) => {
      if (currentLine.length + word.length + 1 <= maxCharactersInRow) {
        currentLine += (currentLine ? " " : "") + word;
      } else {
        wrappedLine.push(currentLine);
        currentLine = word;
      }
    });

    if (currentLine) {
      wrappedLine.push(currentLine);
    }

    return wrappedLine.join("\n");
  });

  const formattedDescription = lines.join("\n");
  e.target.value = formattedDescription;
  setValue("description", formattedDescription);
  
  await trigger("description");
};

